import React from 'react';
import { Form } from 'react-bootstrap';
import { AddPhotoIcon, VideoIcon, DeleteImg, CameraIconPlus } from '../../components/Icons';
import Avatar from '../../components/Avatar';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from "swiper/react";
import CarouselVideo from 'components/CarouselVideo';
import { useState } from "react"
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css"

// import "./styles.css";
import SwiperCore, {
  Pagination
} from 'swiper/core';
import { values } from 'lodash-es';

// install Swiper modules
SwiperCore.use([Pagination]);
const FileUpload = ({ files, handleChange, handleRemove }) => {
  const { t } = useTranslation();
  const postMediaRef = React.useRef(null);

  const selectfileSelect = event => {
    if (files.length < 11) {
      handleChange(Array.from(event.target.files));
      event.target.value = '';
    }
  };

  function createObjURL ( blobPieces ) {
    let blob = new Blob(blobPieces);
    if ( window.webkitURL ) {
        return window.webkitURL.createObjectURL( blob );
    } else if ( window.URL && window.URL.createObjectURL ) {
        return window.URL.createObjectURL( blob );
    } else {
        return null;
    }
  }

  return (
    <div className="post-file-upload">
      <div className="d-flex align-items-center add-media-container">
        <Form.File id="formcheck-api-custom" custom>
          <Form.File.Input
            accept=".jpg,.jpeg,.webp,.gif,.bmp,.png,.m4v,.avi,.mpg,.mp4,.webm,.mp3,.mov"
            onChange={event => selectfileSelect(event)}
            multiple
            ref={postMediaRef}
            style={{ display: 'none' }}
          />

          <Form.Label
            data-browse="Button text"
            className="d-flex mb-0 px-3 py-2 cursor-pointer align-items-center add-media-text"
          >
            {t('media_to_post')}
            <CameraIconPlus width={27} className="file-upload-icon" />
          </Form.Label>
        </Form.File>
      </div>
      {!!files.length && (
        <div className="d-flex flex-wrap ">
            {files.map((el, index) => {
              var binaryData = [];
              binaryData.push(el.file);
              let VideoSrc = el.orig_src ? el.orig_src : window.URL.createObjectURL(new Blob(binaryData, { type: "application/zip" }))

              return (
                  <div key={`image_${index}`} className=" position-relative uploaded-image-cont">
                    {el && el.mime_type === "image" ? (
                      <Avatar image={el.orig_src} size={'100%'} style={{ borderRadius: 8 }} />
                    ) : (
                      el.image ?
                        <Avatar image={el.image} size={'100%'} style={{ borderRadius: 8 }} /> : 
                        <>
                    
                       <CarouselVideo
                          src={ el.orig_src ? el.orig_src+'#t=0.1' : createObjURL(binaryData)+'#t=0.1'}   
                          ext={ el.thumb_src ? el.thumb_src : ''}     
                          index={index}
                          disabled
                          videoStyles={{ width: "100%", height: '100%' }}
                          showFullScreen
                        />
                        
                        
                        </>
                       
                    )}
                    <div className="remove-uploaded-file" onClick={() => handleRemove(el, index)}>
                      <DeleteImg width={16} height={16} />
                    </div>
                  </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
